import { Chip, ChipProps } from '@mui/material'

export type StatusChipProps = ChipProps & {
  status: 'warning' | 'confirm' | 'error' | 'unknown'
}

/**
 * This status chip follows the Compass Design spec.
 */
export const StatusChip = ({ status, sx = {}, ...chipProps }: StatusChipProps) => {
  const bgColors: Record<StatusChipProps['status'], string> = {
    warning: 'var(--bg-surface-warning-transparent)',
    confirm: 'var(--bg-surface-confirm-transparent)',
    error: 'var(--bg-surface-error-transparent)',
    unknown: 'var(--shape-medium)'
  }

  return (
    <Chip
      {...chipProps}
      sx={{
        bgcolor: bgColors[status],
        color: 'var(--text-primary)',
        textTransform: 'capitalize',
        lineHeight: 'var(--line-height-s)',
        letterSpacing: 'var(--letter-spacing-xs)',
        height: 'auto',
        '& .MuiChip-icon': { fontSize: 'var(--icons-xs)' },
        ...sx
      }}
    />
  )
}
